import { render } from "./DatasetBenchmarksTooltip.vue?vue&type=template&id=73f9661f"
import script from "./DatasetBenchmarksTooltip.vue?vue&type=script&lang=js"
export * from "./DatasetBenchmarksTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__